<template>
    <!-- 待办详情抽屉 -->
    <el-drawer
        title="待办详情"
        :visible.sync="drawerShow"
        :wrapperClosable="true"
        :destroy-on-close="true"
        size="600px"
        append-to-body
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <template v-if="detail">
                <!-- 待办基本信息 -->
                <el-card header="待办基本信息" shadow="never">
                    <el-descriptions :column="2" border size="small">
                        <el-descriptions-item label="标题" :span="2">{{ detail.taskInfo.title }}</el-descriptions-item>
                        <el-descriptions-item label="待办内容" :span="2">{{ detail.taskInfo.content }}</el-descriptions-item>
                        <el-descriptions-item label="状态">
                            <el-tag
                                :type="detail.taskInfo.status === 1 ? 'danger' : detail.taskInfo.status === 2 ? 'success' : 'info'"
                                size="small"
                            >{{ detail.taskInfo.statusDesc }}</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="优先级" >
                            <el-tag
                                :type="detail.taskInfo.priority === 1 ? 'danger' : detail.taskInfo.priority === 2 ? 'warning' : 'info'"
                                size="small"
                            >{{ detail.taskInfo.priorityDesc }}</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="完成方式">{{ detail.taskInfo.completeType == 1 ? '任一完成（任一人完成即结束任务并停止后续提醒）' : '全部完成（所有处理人完成才结束任务）' }}</el-descriptions-item>
                        <el-descriptions-item label="分类">
                            {{ (categoryList.find(item => item.key == detail.taskInfo.categoryId) || {}).value || '未分类' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="计划执行时间">{{ detail.taskInfo.deadline }}</el-descriptions-item>
                        <el-descriptions-item label="创建人">{{ detail.taskInfo.createUserName }}</el-descriptions-item>
                        <el-descriptions-item label="创建时间">{{ detail.taskInfo.createTime }}</el-descriptions-item>
                        <el-descriptions-item label="完成人">{{ detail.taskInfo.completeUserName }}</el-descriptions-item>
                        <el-descriptions-item label="完成时间">{{ detail.taskInfo.completeTime }}</el-descriptions-item>
                        <el-descriptions-item label="即将超期">{{ detail.taskInfo.nearDeadline ? '是' : '否' }}</el-descriptions-item>
                        <el-descriptions-item label="已超期">{{ detail.taskInfo.overdue ? '是' : '否' }}</el-descriptions-item>
                        <el-descriptions-item label="备注">{{ detail.taskInfo.remark }}</el-descriptions-item>
                    </el-descriptions>
                </el-card>
                <!-- 提醒配置 -->
                <el-card v-if="detail.remindConfig" header="提醒配置" shadow="never">
                    <template v-if="detail.remindConfig.firstRemind">
                        <h4 class="remind-title">第一轮提醒</h4>
                        <el-descriptions :column="2" border size="small" class="MT10">
                            <el-descriptions-item label="提醒时间">{{ detail.remindConfig.firstRemind.remindTime }}</el-descriptions-item>
                            <el-descriptions-item label="实际提醒时间">{{ detail.remindConfig.firstRemind.actualRemindTime }}</el-descriptions-item>
                            <el-descriptions-item label="提醒状态">
                                <el-tag
                                    :type="detail.remindConfig.firstRemind.remindStatus === 1 ? 'info' : 'success'"
                                    size="small"
                                >{{ detail.remindConfig.firstRemind.remindStatusDesc }}</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label="飞书提醒">{{ detail.remindConfig.firstRemind.feishuRemind === 1 ? '开启' : '关闭' }}</el-descriptions-item>
                        </el-descriptions>
                    </template>
                    <template v-if="detail.remindConfig.secondRemind">
                        <h4 class="remind-title MT20">第二轮提醒</h4>
                        <el-descriptions :column="2" border size="small" class="MT10">
                            <el-descriptions-item label="提醒时间">{{ detail.remindConfig.secondRemind.remindTime }}</el-descriptions-item>
                            <el-descriptions-item label="实际提醒时间">{{ detail.remindConfig.secondRemind.actualRemindTime }}</el-descriptions-item>
                            <el-descriptions-item label="提醒状态">
                                <el-tag
                                    :type="detail.remindConfig.secondRemind.remindStatus === 1 ? 'info' : 'success'"
                                    size="small"
                                >{{ detail.remindConfig.secondRemind.remindStatusDesc }}</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label="飞书提醒">{{ detail.remindConfig.secondRemind.feishuRemind === 1 ? '开启' : '关闭' }}</el-descriptions-item>
                        </el-descriptions>
                    </template>
                </el-card>
                <!-- 关联对象 -->
                <el-card v-if="detail.taskInfo.relatedObjects && detail.taskInfo.relatedObjects.length" header="关联对象" shadow="never">
                    <div v-for="item in detail.taskInfo.relatedObjects" :key="item.objectId" class="MT10">
                        <!-- 架构师意见③：el-link(:href) 渲染裸 <a> 整页加载，改 router-link 走 vue-router -->
                        <router-link class="el-link el-link--default related-object-link"
                            :to="item.objectType == 1 ? `/activityManage/activity/edit/baseInfo/${item.objectId}` : `/activityManage/touring/manage/${item.objectId}`"
                            target="_blank">
                            「{{ item.objectTypeDesc }}」 {{ item.objectName }}
                            <i class="el-icon-right el-icon"></i>
                        </router-link>
                    </div>
                </el-card>
                <!-- 处理人列表 -->
                <el-card v-if="detail.taskInfo.assignees && detail.taskInfo.assignees.length" header="处理人" shadow="never">
                    <el-table :data="detail.taskInfo.assignees" border size="mini">
                        <el-table-column prop="assigneeName" label="处理人姓名" show-overflow-tooltip></el-table-column>
                        <el-table-column label="处理状态" width="100">
                            <template slot-scope="scope">
                                <el-tag
                                    :type="scope.row.assigneeStatus === 1 ? 'info' : 'success'"
                                    size="small"
                                    disable-transitions
                                >{{ scope.row.assigneeStatus === 1 ? '待处理' : '已完成' }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="completeTime" label="完成时间" show-overflow-tooltip></el-table-column>
                    </el-table>
                </el-card>
                <!-- 操作记录 -->
                <el-card v-if="detail.operationLogs && detail.operationLogs.length" header="操作记录" shadow="never">
                    <el-timeline>
                        <el-timeline-item
                            v-for="item in detail.operationLogs"
                            :key="item.createTime"
                            :timestamp="item.createTime"
                            placement="top"
                        >
                            <p><strong>{{ item.operatorName }}</strong> - {{ item.operationTypeDesc }}</p>
                            <p>{{ item.operationContent }}</p>
                        </el-timeline-item>
                    </el-timeline>
                </el-card>
            </template>
        </div>
        <div v-if="detail" class="drawer-footer">
            <div class="flex" style="flex: 1;padding: 0 20px;">
                <div class="flex-1">
                    <el-input v-model.trim="recordContent" placeholder="请输入备注" maxlength="200" show-word-limit></el-input>
                </div>
                <div>
                    <el-button type="primary" @click="send">发送</el-button>
                    <el-button v-if="detail.taskInfo && detail.taskInfo.status == 1" type="warning" plain @click="handleManualRemind">手动提醒</el-button>
                    <el-button v-if="detail.taskInfo && detail.taskInfo.status == 1" type="warning" @click="handleComplete">标记完成</el-button>
                </div>
            </div>
        </div>
        <!-- 完成弹窗 -->
        <complete ref="completeRef" @onSuccess="onCompleteSuccess"></complete>
    </el-drawer>
</template>

<script>
import Complete from './Complete.vue'
export default {
    name: 'Detail',
    components: {
        Complete,
    },
    data() {
        return {
            id: '', // 待办ID
            drawerShow: false, // 抽屉显示状态
            dataLoading: false, // 加载状态
            detail: null, // 详情数据
            // 分类列表
            categoryList: [],
            recordContent: '', // 备注内容
        };
    },
    mounted() {
        this.getCategoryList();
    },
    methods: {
        // 关闭抽屉
        close() {
            this.drawerShow = false;
            this.detail = null;
        },
        // 打开详情抽屉
        open(id) {
            this.id = id;
            this.drawerShow = true;
            this.getDetail();
        },
        // 获取分类列表
        async getCategoryList() {
            const res = await this.$request({
                url: "/pendingtask/categorySelect",
                method: "post",
            });
            const { state, result } = res.data;
            if (state == 1) {
                this.categoryList = result || [];
            }
        },
        // 获取待办详情
        async getDetail() {
            this.dataLoading = true;
            try {
                const res = await this.$request({
                    url: '/pendingtask/detail',
                    method: 'post',
                    data: { pendingTaskId: this.id },
                });
                const { state, result } = res.data;
                if (state == 1 && result) {
                    this.detail = result;
                }
            } catch (err) {
                this.$message.error('获取详情失败');
            } finally {
                this.dataLoading = false;
            }
        },
        // 发送备注
        send() {
            if (!this.recordContent) {
                return;
            }
            this.$request({
                url: '/pendingtask/addRecord',
                method: 'post',
                data: {
                    pendingTaskId: this.detail.taskInfo.id,
                    content: this.recordContent,
                },
            }).then((res) => {
                const { state, errmsg } = res.data;
                if (state) {
                    this.recordContent = '';
                    this.getDetail();
                } else {
                    this.$message.error(errmsg || '发送失败');
                }
            });
        },
        // 手动提醒（需求7139979129：立即向待处理人发送提醒消息）
        handleManualRemind() {
            this.$confirm('将立即向待处理人发送提醒消息，是否继续？', '手动提醒', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.$request({
                    url: '/pendingtask/manualRemind',
                    method: 'post',
                    data: {
                        pendingTaskId: this.detail.taskInfo.id,
                    },
                }).then((res) => {
                    const { state, msg, errmsg } = res.data;
                    if (state == 1) {
                        this.$message.success('提醒已发送');
                        this.getDetail();
                    } else {
                        this.$message.error(msg || errmsg || '发送提醒失败');
                    }
                }).catch(() => {
                    this.$message.error('发送提醒失败');
                });
            }).catch(() => {});
        },
        // 标记完成
        handleComplete() {
            this.$refs.completeRef.open({
                id: this.detail.taskInfo.id,
                title: this.detail.taskInfo.title,
            });
        },
        // 完成弹窗成功回调
        onCompleteSuccess() {
            this.$router.replace({
                path: `/workbench/work`,
                query: {
                    ...this.$route.query,
                    v: new Date().getTime(),
                },
            });
            this.close();
        },
    },
};
</script>

<style lang="scss" scoped>
.flex {
    display: flex;

    &.items-center {
        align-items: center;
    }

    &.justify-between {
        justify-content: space-between;
    }

    .flex-1 {
        flex: 1;
    }
}
// 架构师意见③：router-link 替代 el-link(:href) 后补齐原链接视觉
.related-object-link {
    color: #409EFF;
    font-size: 14px;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}
</style>